export { default } from './CreateCreditCardPayment.data';
